import React from 'react';
import GlyphSvg from './Glyphs';

export default function TextBlock() {
    return (
      <div className="container pt-lg-5 mt-lg-5 mb-5 text-center c-c2">
        <h5 className="pb-4 f-uc f-a">Increase asset output</h5>
        <h1 className="f-a large-title c-c00">
          Supercharge your marketing <br /> from one <GlyphSvg glyph={'g01'} size={"32"} /> image into
          endless <GlyphSvg glyph={'g02'} size={"32"} /> iterations.
        </h1>
        <h5 className="pt-4"><GlyphSvg glyph={'g09'} size={"32"} color={"var(--c00)"} /> </h5>
      </div>
    );
}   